import apiConfig from "../config/api";

const serieCI = () => sessionStorage.getItem("serialCIActivacion");
const usuarioRUT = () => sessionStorage.getItem("rutUsuarioActivacion");
/**
 * @description Request para consumir la API para la validación de identidad
 * a usuarios con problemas de cuenta
 * @param {*} usuarioRUT RUT del usuario que desea validar identidad
 * @param {*} serieCI Numero de serie del carnet del usuario
 */

const getToken = () => localStorage.getItem("AccessToken");
export const validarIdentidadUsuario = () =>
  fetch(`${apiConfig.apiUri}api/user/troubleshooting/state`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
      "auth-rut": usuarioRUT(),
      "auth-serie-ci": serieCI(),
    }
  });

// MOCK
// export const validarIdentidadUsuario = () => new Promise((res) => {
//   res({
//     json: () => ({
//       "Id": "48117584-4691-45ce-94c5-c2119aadf9a9",
//       "Status": 410,
//       "Message": "Bloqueo Bloqueo Bloqueo",
//       "Payload": {
//           "Email": "",
//           "Phone": "",
//           "EmailMasked": "",
//           "PhoneMasked": ""
//       }
//   })
//   });
// });

/**
 * @description Request para consumir la API de envio de correoy SMS para
 * el nuevo fluko de activacion de cuentas
 * @param {*} usuarioRUT RUT del usuario que desea validar identidad
 * @param {*} serieCI Numero de serie del carnet del usuario
 * @param {*} datos Objeto con el numero de telefono y el email de la paersona
 */
export const envioEmailSMSActivacionCuenta = (datos) =>
  fetch(`${apiConfig.apiUri}api/user/troubleshooting/resolve`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "auth-rut": usuarioRUT(),
      "auth-serie-ci": serieCI(),
    },
    body: JSON.stringify(datos)
  });

/**
 * Validación de identidad sin validación numero de serie
 * @returns
 */
export const validarIdentidadUsuarioNoSerie = () =>
  fetch(`${apiConfig.apiUri}api/user/troubleshooting/statenoserie`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
      "auth-rut": usuarioRUT(),
    }
  });

export const envioEmailSMSActivacionCuentaNoSerie = () =>
  fetch(`${apiConfig.apiUri}api/user/troubleshooting/resolvenoserie`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "auth-rut": usuarioRUT(),
    },
    body: JSON.stringify({})
  });
